var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jersey-button',{attrs:{"isDisabled":_vm.isDisabled,"action":_vm.action,"view":_vm.view}},[_c('div',{staticClass:"yellowButton"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }